import React, { useState } from "react";
import { Drawer, Button, Col, Row } from "antd"
import { MenuOutlined } from "@ant-design/icons"

const NavBar = ({ menu, username }) => {
  const [visible, setVisible] = useState(false);
  return (
    <nav className="navbar">
        <Row>
            <Col xs={12} md={12}>
                <a href="/"><img src="/assets/images/background/jubilee-logo.svg" className="logo" alt="logo" /></a>     
            </Col>

            <Col xs={0} sm={0} md={12}>
                <div className="user_head">
                    <h6>Welcome <span> { username } </span></h6>
                </div>
            </Col>

            <Col xs={12} sm={0} md={0} style={{margin:"auto"}}>
                <Button
                    className="menu"
                    type="primary"
                    icon={<MenuOutlined />}
                    onClick={() => setVisible(true)}
                />
            </Col>
        </Row>

        <Drawer
            title=""
            placement="left"
            onClick={() => setVisible(false)}
            onClose={() => setVisible(false)}
            visible={visible}
        > 
            {menu}
        </Drawer>

    </nav>
  )
}

export default NavBar